import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '../../contexts/ThemeContext';
import { TourPartyMemberAvatar } from './TourPartyMemberAvatar';
import { TourPartyMemberCardShell } from './TourPartyMemberCardShell';
import { resolveMemberLabel } from '../../utils/tourPartyMemberUtils';

/** Compact pickable chip for Rider "Add tour party" row. */
export function TourPartyMemberChip({ member, theme, isDarkMode, onPress, selected = false, showAddBadge = true }) {
  const { isDarkMode: ctxDark } = useTheme();
  const dark = isDarkMode ?? ctxDark;
  const displayName = resolveMemberLabel(member);

  return (
    <TourPartyMemberCardShell
      isDarkMode={dark}
      onPress={onPress}
      style={[
        styles.chip,
        selected && { borderColor: theme.brand.primary, borderWidth: 2 },
        !onPress && selected && { opacity: 0.72 },
        { overflow: 'hidden' },
      ]}
    >
      <View style={styles.chipBody}>
        {showAddBadge ? (
          <View style={[styles.addBadge, { backgroundColor: theme.brand.primary }]}>
            <Ionicons name="add" size={11} color={theme.button.primaryText} />
          </View>
        ) : selected ? (
          <View style={[styles.addBadge, { backgroundColor: theme.brand.primary }]}>
            <Ionicons name="checkmark" size={11} color={theme.button.primaryText} />
          </View>
        ) : null}
        <TourPartyMemberAvatar member={member} size={36} theme={theme} />
        <Text style={[styles.name, { color: theme.text.primary }]} numberOfLines={1}>
          {displayName.split(' ')[0] || displayName}
        </Text>
        {member.userTypeLabel ? (
          <Text
            style={[styles.type, { color: member.userTypeColor || theme.text.secondary }]}
            numberOfLines={1}
          >
            {member.userTypeLabel}
          </Text>
        ) : null}
      </View>
    </TourPartyMemberCardShell>
  );
}

const styles = StyleSheet.create({
  chip: {
    width: 84,
  },
  chipBody: {
    alignItems: 'center',
    gap: 4,
    paddingVertical: 10,
    paddingHorizontal: 6,
    position: 'relative',
    zIndex: 2,
  },
  name: {
    fontSize: 10,
    fontWeight: '800',
    textAlign: 'center',
    maxWidth: '100%',
  },
  type: {
    fontSize: 8,
    fontWeight: '700',
    textAlign: 'center',
    maxWidth: '100%',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  addBadge: {
    position: 'absolute',
    top: 5,
    right: 5,
    width: 16,
    height: 16,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 3,
  },
});

export default TourPartyMemberChip;
